var React = require('react');

function Mouse (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0zM0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 192v32H0v-32h176V0h32v192z","className":"fa-primary","key":2})]);
}

Mouse.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Mouse;

Mouse.default = Mouse;
